exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content_wrap[data-v-edd87646]{padding-top:33px}.content_wrap .content[data-v-edd87646]{font-size:14px;width:776px;word-break:break-all;line-height:1.8}.content_wrap .download_wrap[data-v-edd87646]{margin-top:20px}.content_wrap .download_wrap .download[data-v-edd87646]{font-size:14px}.content_wrap .download_wrap .download a[data-v-edd87646]{margin-left:4px;color:#c00}.easy_info[data-v-edd87646]{padding-top:7px}.easy_info .info[data-v-edd87646]{line-height:44px;font-size:16px;color:#666;font-weight:600}.easy_info .detail[data-v-edd87646]{line-height:25px;font-size:14px;text-indent:28px;color:#666;word-break:break-word}", ""]);

// exports
